export enum Style {
    BackgroundUrl = 'bg_url',
    PageBackgroundUrl = 'page_bg_url',
    AnswerTextColor = 'answer_text_color',
    AddPad = 'add_pad',
    AlignControls = 'align_controls',
    ButtonBorderRadius = 'button_border_radius',
    ControlOpacity = 'control_opacity',
    ControlsColor = 'controls_color',
    FontFamily = 'font_family',
    FormBorderRadius = 'form_border_radius',
    FormOpacity = 'form_opacity',
    FormPadding = 'form_padding',
    QuestionTextColor = 'question_text_color',
    PageTitleColor = 'page_title_color',
    BackgroundColor = 'bg_color',
    BackgroundGradient = 'bg_gradient',
    PageBackgroundColor = 'page_bg_color',
    BodyPadding = 'body_padding',
    ControlsTextColor = 'controls_text_color',
    ControlsColorHover = 'controls_color_hover',
    SecondaryTextColor = 'secondary_text_color',
    HintTextColor = 'hint_text_color',
    FieldBackgroundColor = 'field_background_color',
    AnswerLineColor = 'answer_line_color',
    AnswerLineHoverColor = 'answer_line_hover_color',
    QuestionLineColor = 'question_line_color',
    SeriesBackgroundColor = 'series_background_color',
    StarsBackgroundColor = 'stars-bg-color',
    StarsBackgroundColorHover = 'stars-bg-color-hover',
}

export enum AlignControlValue {
    Left = 'left',
    Center = 'center',
    Right = 'right',
}
